import { render, staticRenderFns } from "./TitleRemark.vue?vue&type=template&id=1edb5cd2&scoped=true&"
import script from "./TitleRemark.vue?vue&type=script&lang=js&"
export * from "./TitleRemark.vue?vue&type=script&lang=js&"
import style0 from "./TitleRemark.vue?vue&type=style&index=0&id=1edb5cd2&prod&scoped=true&lang=css&"
import style1 from "./TitleRemark.vue?vue&type=style&index=1&id=1edb5cd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb5cd2",
  null
  
)

export default component.exports